import { useState } from "react"
import { X, Send, Paperclip, ImageIcon, Smile } from "lucide-react"

export function ThreadView({ message, onClose }) {
  const [reply, setReply] = useState("")

  return (
    <div className="fixed inset-y-0 right-0 w-96 bg-white dark:bg-gray-900 border-l border-gray-200 dark:border-gray-800 z-30">
      <div className="flex flex-col h-full">
        <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-800">
          <h3 className="text-lg font-bold dark:text-white">Thread</h3>
          <button onClick={onClose} className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800">
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-4">
          {/* Original message */}
          <div className="flex items-start gap-4 pb-6 mb-6 border-b border-gray-200 dark:border-gray-800">
            <div className="relative shrink-0">
              <img src={message.avatar || "/placeholder.svg"} alt={message.user} className="w-10 h-10 rounded-xl" />
              {message.isOnline && (
                <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-white dark:border-gray-900" />
              )}
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <span className="font-semibold dark:text-white">{message.user}</span>
                <span className="text-xs text-gray-400">{message.time}</span>
              </div>
              <p className="mt-1 text-gray-700 dark:text-gray-300">{message.message}</p>
              {message.attachments?.map((attachment, index) => (
                <div key={index} className="mt-2">
                  {attachment.type === "image" && (
                    <img
                      src={attachment.url || "/placeholder.svg"}
                      alt={attachment.preview || "Attachment"}
                      className="max-w-full rounded-xl border border-gray-200 dark:border-gray-700"
                    />
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Thread replies would go here */}
          <div className="space-y-6">
            {/* Example replies */}
            {[1, 2].map((i) => (
              <div key={i} className="flex items-start gap-4">
                <img src="/placeholder.svg?height=40&width=40" alt="User avatar" className="w-8 h-8 rounded-xl" />
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <span className="font-semibold dark:text-white">User {i}</span>
                    <span className="text-xs text-gray-400">Just now</span>
                  </div>
                  <p className="mt-1 text-gray-700 dark:text-gray-300">Example reply {i}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Reply input */}
        <div className="p-4 border-t border-gray-200 dark:border-gray-800">
          <div className="flex items-center gap-2 bg-gray-100 dark:bg-gray-800 p-2 rounded-xl">
            <div className="flex gap-1">
              <button className="p-2 rounded-lg hover:bg-white dark:hover:bg-gray-700">
                <Paperclip className="w-5 h-5 text-gray-500" />
              </button>
              <button className="p-2 rounded-lg hover:bg-white dark:hover:bg-gray-700">
                <ImageIcon className="w-5 h-5 text-gray-500" />
              </button>
            </div>
            <input
              type="text"
              value={reply}
              onChange={(e) => setReply(e.target.value)}
              placeholder="Reply to thread..."
              className="flex-1 px-4 py-2 bg-transparent border-0 focus:outline-none focus:ring-0 dark:text-white placeholder-gray-500"
            />
            <div className="flex gap-1">
              <button className="p-2 rounded-lg hover:bg-white dark:hover:bg-gray-700">
                <Smile className="w-5 h-5 text-gray-500" />
              </button>
              <button className="px-4 py-2 bg-purple-500 hover:bg-purple-600 text-white rounded-lg flex items-center gap-2">
                <Send className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

